import { USER_REPORTS_ROUTE } from "../../constants/routes"

const nonSsoDomains = new Set([
    // Environments
    "prod.facilitynet.dk",
    "qa.facilitynet.dk",
    "demo.facilitynet.dk",
    "test.facilitynet.dk",

    // Vanity domains
    "app.facilitynet.dk",
    "app.facilitynet.io",
])

export function isPossibleSsoTenant(host: string) {
    if (nonSsoDomains.has(host)) {
        return false
    }

    return true
}

function getUserHomeUrl() {
    // 1. Get the base bits from the browser
    const host = window.location.origin; // e.g., https://tenant-a.com
    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    // 2. Grab the app name (the first segment)
    // If pathname is "/gate-app/dashboard", appName is "gate-app"
    const appName = pathSegments[0] || "";

    // 3. Construct the Return URL
    // We join the appName with the userHome route
    // Using URL constructor handles the slashes correctly
    const returnUrl = new URL(`${appName}${USER_REPORTS_ROUTE}`, host).toString();

    return returnUrl
}

export function getSsoGatewayBaseUrl(currentUrl: string) {
    if (currentUrl.endsWith("/")) {
        currentUrl = currentUrl.substring(0, currentUrl.length - 1)
    }
    return new URL("/gate", currentUrl)
}

export function getSsoRedirectUrl(currentUrl: string, ssoRelativeUrl: string) {
    if (currentUrl.endsWith("/")) {
        currentUrl = currentUrl.substring(0, currentUrl.length - 1)
    }
    const returnUrl = getUserHomeUrl()
    const redirectUrl = new URL(ssoRelativeUrl, currentUrl)
    redirectUrl.searchParams.set("return", returnUrl)
    return redirectUrl
}
